import { faEye, faTrashCan } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from '@redux';
import crudSelectors from '@redux/crudSelectors';
import { Button, Space } from 'antd';
import DelModal from 'components/commons/ModalCustom/DelModal';
import React, { Dispatch, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { DynamicObjectType } from 'types/commons';

interface IActionCol {
  model?: string;
  hasEdit?: boolean;
  hasDel?: boolean;
  hasShow?: boolean;
  record: DynamicObjectType;
  data: string;
  index: number;
  extraActions?: React.ReactElement[];
  gotoShowPage?: (id: string) => void;
  gotoEditPage?: (id: string) => void;
  setSelectedRowKeys?: Dispatch<React.SetStateAction<React.Key[]>>;
  selectedRowKeys?: React.Key[];
  customDescDelete?: string;
}

export default function IActionCol({
  model,
  hasEdit,
  gotoShowPage,
  gotoEditPage,
  hasDel,
  customDescDelete,
  hasShow,
  record,
  data,
  index,
  extraActions,
  setSelectedRowKeys,
  selectedRowKeys,
}: IActionCol) {
  const { t } = useTranslation();
  const deleteRef = useRef<{ open: () => void }>();
  const loading = useSelector<boolean>(crudSelectors[model].getLoading);

  return (
    <Space>
      {hasShow && (
        <Button
          type="text"
          onClick={() => gotoShowPage?.(record?.id as string)}
          icon={
            <FontAwesomeIcon
              icon={faEye}
              className="title-gray-color text-lg"
            />
          }
        />
      )}
      {hasEdit && (
        <Button
          type="text"
          icon={<FontAwesomeIcon icon={faEye} className='title-gray-color text-lg' />}
          onClick={() => gotoEditPage?.(record?.id as string)}
        />
      )}
      {React.Children.map(extraActions, (child) =>
        React.cloneElement(child, {
          record,
          data,
          index,
          model,
          setSelectedRowKeys,
          selectedRowKeys,
        }),
      )}
      {hasDel && (
        <Button
          loading={loading}
          type="text"
          icon={
            <FontAwesomeIcon
              icon={faTrashCan}
              className="text-inactive-red text-lg"
            />
          }
          onClick={() => deleteRef.current.open()}
        />
      )}
      <DelModal
        modal={model}
        title={`${t(`common.page.${model}`)}`}
        customDesc={customDescDelete}
        ref={deleteRef}
        record={record}
        isBack={false}
      />
    </Space>
  );
}
